import { axiosClient } from "@/lib/axios";
import { HttpError } from "@/types/error";
import { PublicAnnouncement } from "@classview/shared-types";
import { UseQueryOptions, useQuery } from "@tanstack/react-query";

export const getAnnouncements = async (): Promise<PublicAnnouncement[]> => {
  const response = await axiosClient.get("/announcements");
  return response.data;
};

export const announcementsQueryKey = ["announcements"];

export function useGetAnnouncements(
  queryOptions?: Partial<UseQueryOptions<PublicAnnouncement[], HttpError>>,
) {
  return useQuery({
    queryKey: announcementsQueryKey,
    queryFn: () => getAnnouncements(),
    ...queryOptions,
  });
}
